const ErrorColor = {
  100: '#DE2D2D',
  90: '#E14242',
  80: '#E55757',
  30: '#F5C0C0',
  10: '#FCEAEA',
};

export default ErrorColor;
